import _ from 'lodash';
import Promise from 'bluebird';
import helpers from '../../helpers';
import {
    generateResourceStore,
    generateResourceGetters,
    generateResourceActions,
    generateResourceMutations,
} from '../generators';

// initial state
const createState = () => {
    return Promise.resolve({
        ...generateResourceStore(),
        localPanels: [],
        globalPanels: [],
    });
}

// getters
const getters = {
    ...generateResourceGetters(),
    localPanels: (state) => state.localPanels,
    globalPanels: (state) => state.globalPanels,
}

// actions
const createActions = (helpers) => ({
    ...generateResourceActions(helpers),

    getInitialData({ commit }, pagePath) {
        const path = helpers.uriFormat(pagePath);
        commit('setPath', `${path}/attached_panels?schema`);

        return Promise.all([
            helpers.api.getData('/panels', { per_page: 9999 }),
            helpers.api.getData(`${path}/panels`),
            helpers.api.getData(`${path}/attached_panels`, { schema: true }),
        ]).then(([globalPanels, localPanels, attachedPanels]) => {
            commit('setGlobalPanels', globalPanels.data);
            commit('setLocalPanels', localPanels.data);
            commit('setContent', attachedPanels);
        })
    }
})

// mutations
const mutations = {
    ...generateResourceMutations('PagePanels'),
    setGlobalPanels(state, data) {
        state.globalPanels = data;
    },
    setLocalPanels(state, data) {
        state.localPanels = data;
    },
}

export default (helpers) => {
    return Promise.all([
        createState(),
        createActions(helpers),
    ])
        .then(([state, actions]) => ({
            namespaced: true,
            state,
            getters,
            actions,
            mutations,
        }))
}



// WEBPACK FOOTER //
// ./seventytwo/72cms-ui/src/store/modules/panels.js